// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tMOieEejUZgiFYS5V_yy{grid-template-rows:auto 1fr;height:412px;display:grid}.cKktcCLET308oBBEUt2V{grid-template-rows:1fr}.E4hm7MKK5EtPMGY5PwbD{border-top:1px solid var(--border-neutral-default);padding:15px 0 10px}.UtJGhHWls_wClpmzV5tL{grid-template-columns:1fr auto;display:inline-grid}.UtJGhHWls_wClpmzV5tL input{font-size:16px;font-weight:500}.aZbG5zg5QpQdDJd0z0Ig{grid-template-rows:auto 1fr;display:grid}.c9Dx0LO3K8EEXKBylwWt{padding:6px 0}.oQqepkscRXkEvDS_VJ3o{flex-direction:column;justify-content:center;align-items:center;padding-bottom:28px;display:flex}.DbSulNzsgwkjWuKysyur{color:var(--content-brand-primary);margin-bottom:16px}.RGjqt97ClicmBntBjPeP{color:var(--content-primary-primary);margin-bottom:8px}.l4rf8UuRZAQCBnPSwZ19{text-align:center;color:var(--content-primary-tertiary)}.l4rf8UuRZAQCBnPSwZ19 a{color:var(--content-brand-primary);font-weight:500;text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `tMOieEejUZgiFYS5V_yy`,
	"wrap--spinner": `cKktcCLET308oBBEUt2V`,
	"wrapSpinner": `cKktcCLET308oBBEUt2V`,
	"inputWrap": `E4hm7MKK5EtPMGY5PwbD`,
	"input": `UtJGhHWls_wClpmzV5tL`,
	"filterWrap": `aZbG5zg5QpQdDJd0z0Ig`,
	"filterBtn": `c9Dx0LO3K8EEXKBylwWt`,
	"filterEmpty": `oQqepkscRXkEvDS_VJ3o`,
	"filterEmpty__icon": `DbSulNzsgwkjWuKysyur`,
	"filterEmptyIcon": `DbSulNzsgwkjWuKysyur`,
	"filterEmpty__title": `RGjqt97ClicmBntBjPeP`,
	"filterEmptyTitle": `RGjqt97ClicmBntBjPeP`,
	"filterEmpty__desc": `l4rf8UuRZAQCBnPSwZ19`,
	"filterEmptyDesc": `l4rf8UuRZAQCBnPSwZ19`
};
export default ___CSS_LOADER_EXPORT___;
